export const ViewDates = {

    computed: {
        viewStartDate() {
            switch (this.view) {
                case 'day':
                    return moment(this.date).startOf('day');
                case 'month':
                    return moment(this.date).startOf('month');
                case 'schedule':
                    return null;
                case 'free_places':
                    return moment(this.date).startOf('day');
                default:
                    return moment(this.date).startOf('week');
            }
        },

        viewEndDate() {
            switch (this.view) {
                case 'day':
                    return moment(this.date).endOf('day');
                case 'month':
                    return moment(this.date).endOf('month');
                case 'schedule':
                    return null;
                case 'free_places':
                    return moment(this.date).add(5, 'days').endOf('day');
                default:
                    return moment(this.date).endOf('week');
            }
        },

        viewNumberOfDays() {
            switch (this.view) {
                case 'day':
                    return 1;
                case 'month':
                    return moment(this.date).daysInMonth();
                case 'schedule':
                    return 1000;
                case 'free_places':
                    return 5;
                default:
                    return 7;
            }
        }
    }
};
